import PaymentCardsView from '../../components/Views/Payment/PaymentCardsView';

export default function PaymentsScreen() {
  return <PaymentCardsView></PaymentCardsView>;
}
